// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export const CookiesDisclaimerContainer = styled.div`
  display: flex;
  width: calc(100% - 48px);
  background-color: ${(props) => props.theme.colors.WHITE};
  padding: 16px 24px;
  border-top: 1px solid ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.25);
  z-index: 1;
  justify-content: space-between;
  align-items: center;
  @media ${(props) => props.theme.mediaQuery.large} {
    width: calc(100% - 64px);
    padding: 24px 32px;
  }
`;

export const DisclaimerTextContainer = styled.div`
  width: 85%;
  @media ${(props) => props.theme.mediaQuery.large} {
    width: 75%;
  }
`;

export const ButtonContainer = styled.span`
  height: 15px;
  width: 15px;
  cursor: pointer;
`;

export default css`
  .close-icon {
    filter: brightness(0) saturate(100%) invert(38%) sepia(3%) saturate(22%) hue-rotate(321deg)
      brightness(89%) contrast(93%);
  }
`;
